import React, { useCallback, useLayoutEffect, useMemo } from 'react';
import { StyleSheet } from 'react-native';
import Animated from 'react-native-reanimated';
import Text from 'design-system/Text';
import { AppView } from 'design-system/AppView';
import HeaderImage from 'design-system/HeaderImage';
import Button, { HEIGHT } from 'design-system/Button';
import { rem, SCROLL_INDICATOR_INSETS } from 'design-system/values';
import NavigationCloseButton from 'design-system/NavigationCloseButton';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import { useAppDispatch } from 'store/hooks';
import useColorScheme from 'hooks/useColorScheme';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { setDeviceSettingsKey } from 'actions/deviceSettings';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { SellOrderType } from '../types';
import useStockMeta from '../hooks/useStockMeta';
import { isWeb } from '../../../constants';
const sellGraphics = require('../img/limitSellGraphics.png');
const sellGraphicsDark = require('../img/limitSellGraphicsDark.png');
export default withAnimatedNavigationHeader(({ route, navigation, scrollHandler }) => {
    const dispatch = useAppDispatch();
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const { assetId } = route.params;
    const stockMeta = useStockMeta(assetId);
    const symbol = stockMeta?.symbol;
    const colorScheme = useColorScheme();
    const paddingBottom = useMarginBottom('paddingBottom', HEIGHT + rem(16), styles.contentContainer, paddingHorizontalStyle);
    const handleGoBack = useCallback(() => {
        navigation.pop();
        dispatch(setDeviceSettingsKey('didViewSellLimitOrderIntro', true));
    }, []);
    const handleContinue = useCallback(() => {
        handleGoBack();
        navigation.navigateDeprecated('InvestSetLimitStopPrice', {
            assetId,
            action: 'sell',
            orderType: SellOrderType.LIMIT,
        });
    }, [handleGoBack, assetId]);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerLeft: () => <NavigationCloseButton inWebHeader onPress={handleGoBack}/>,
            headerBackVisible: false,
        });
    }, [handleGoBack]);
    const headerImg = useMemo(() => (colorScheme === 'dark' ? sellGraphicsDark : sellGraphics), [colorScheme]);
    return (<AppView withFrame={false}>
        <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} contentContainerStyle={paddingBottom} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}>
          <HeaderImage source={headerImg} resizeMode="contain" style={styles.headerImgBg} imgStyle={styles.headerImage} onDark/>
          <Text Text-24 style={styles.title}>
            Limit order
          </Text>
          {!!symbol && (<Text TextThin-14 Gray>
              {`Set a limit price, or the price at which you’re willing to sell $${symbol} if the current market price were to rise. Your order will only be executed at your limit price or higher. The default expiry for your order is 90 days and only whole shares are supported.`}
            </Text>)}
        </Animated.ScrollView>
        <Button floating brand title="Got it" onPress={handleContinue}/>
      </AppView>);
}, ({ colors }) => ({
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
const styles = StyleSheet.create({
    contentContainer: {
        paddingTop: rem(16),
        paddingHorizontal: rem(16),
    },
    headerImgBg: {
        height: undefined,
        padding: 0,
    },
    headerImage: {
        width: '100%',
        aspectRatio: 1,
        height: undefined,
    },
    title: {
        marginBottom: rem(9),
    },
});
